
import apiKeyApi from "@/services/api.apiKey.service";
import eventsApi from "@/services/api.event.service";
import aiDataApi from "@/services/api.aiData.service";
import settingsApi from '@/services/api.settings.service';
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { SummaryData } from "@/store/site-monitor/types";
import { Getter } from 'vuex-class';

@Component({})
export default class VirtualAssistSummary extends Vue {
    @Prop({ required: true, type: Number })
    private eventId: number;

    @Prop({ required: false, type: String, default: "" })
    private additionalContext: string;

    private fetchingSummary: boolean = false;
    private apiKey?: string | null = null;
    private tenantId?: string | null = null;

    @Getter getUserTenantGroupId!: number;

    private readonly VirtualOperatorApiKeyName: string = "VirtualOperator";
    private readonly FailedToGenerateSummaryMessage: string = "Failed to generate summary.";
    private readonly notifyErrorMessage: string = "Unable to generate summary for Event - please try again later, or contact support if the problem persists";

    private async mounted(): Promise<void> {
        var aiDataUrl = await settingsApi.getAiDataUrl();
        aiDataApi.setBaseApiUrl(aiDataUrl);

        this.apiKey = await apiKeyApi.getApiKey(this.VirtualOperatorApiKeyName);
        this.tenantId = this.getUserTenantGroupId.toString();
    }

    private async getSummary(): Promise<void> {
        // if already running then skip
        if (this.fetchingSummary == true) {
            return;
        }

        this.fetchingSummary = true;

        try
        {
            var summaryData: SummaryData | null = await eventsApi.getEventSummaryData(this.eventId, this.apiKey);

            var summary: string | null = null;
            if (summaryData) {
                if (this.additionalContext && this.additionalContext.length > 0) {
                    summaryData.additionalContext = this.additionalContext;
                }

                summary = await aiDataApi.generateAiSummary(
                    summaryData,
                    this.apiKey,
                    this.tenantId
                );
            }

            if (summary) {
				this.emitSummaryGenerated(summary);
			}
        } catch (e) {
            console.error(this.FailedToGenerateSummaryMessage, e);

            this.$notify({
                type: "error",
                title: "Virtual Assist - Event Summary",
                text: this.notifyErrorMessage
            });
        }

        this.fetchingSummary = false;
    }

    @Emit("summary-generated")
	private emitSummaryGenerated(summary: string): string {
		return summary;
	}
}
